import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from "@denishussar/html5-game-engine";
import { AnimationContents } from "../../../AnimationContents";
import isMobile from 'is-mobile';

export class FTUEArrowController extends AnimationBaseController {
    $model: any;
    constructor (
        @Inject private options: any,
    ) {
        super('FTUEArrowController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: isMobile() ? AnimationContents.GAME_SCREEN_MOBILE_JSON : AnimationContents.GAME_SCREEN_JSON,
            libraryName: 'ftue_arrow',
        }
    }

    protected onInitialize(): void {
        if (isMobile()) {
            this.rotation = 1.57;
        }
    }
}
